// extracted by mini-css-extract-plugin
module.exports = {"h2":"Graphics_h2__3O9p4","graphics":"Graphics_graphics__7udLh","inputs":"Graphics_inputs__3TNlR"};